
const newModel = () => {
    return {
        lichQuetRacId: null,
        ten: null,
        loaiTuyenduongQuetRacId: null,
        tenLoaiTuyenduongQuetRac: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

const newFEModel = () => {
    return {
        lichQuetRacId: null,
        ten: null,
        loaiTuyenduongQuetRacId: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        lichQuetRacId: item.lichQuetRacId,
        ten: item.ten,
        loaiTuyenduongQuetRacId: item.loaiTuyenduongQuetRacId,
        tenLoaiTuyenduongQuetRac: item.tenLoaiTuyenduongQuetRac,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const parseModeltoFEModel = (item) => {
    return {
        lichQuetRacId: item.lichQuetRacId,
        ten: item.ten,
        loaiTuyenduongQuetRacId: item.loaiTuyenduongQuetRacId,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const newPagingSearchModel = () => {
    return {
        lichQuetRacId: null,
        ten: null,
        loaiTuyenduongQuetRacId: null,
        ghiChu: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        lichQuetRacId: item.lichQuetRacId,
        ten: item.ten,
        loaiTuyenduongQuetRacId: item.loaiTuyenduongQuetRacId,
        ghiChu: item.ghiChu,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        lichQuetRacId: null,
        ten: null,
        loaiTuyenduongQuetRacId: null,
        ghiChu: null,
        stt: null,
        enabled: null,
    }
}

export const lichQuetRacModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


